import styled from 'styled-components';
import { theme } from '@theme';

export const NotificationWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: #F9F2EC;
  border-radius: 8px;
  max-width: 450px;
  min-width: 450px;
  max-height: 624px;
  min-height: 371px;
  overflow: hidden;

  @media screen and (max-width: ${theme.breakpoints.md}) {
    max-width: none;
    min-width: 100%;
  }

  .notification-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const Notifications = styled.div`
  margin-top: 16px;
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 48px);
`

export const Divider = styled.div`
  height: 1px;
  margin: 17px 0;
  background: rgba(209, 201, 193, 0.5);
`
